import React from "react";
import image1 from "../../Assets/HomePage/image.png";
import image2 from "../../Assets/HomePage/image (1).png";
import image3 from "../../Assets/HomePage/image (2).png";
import image4 from "../../Assets/HomePage/image (3).png";
import image5 from "../../Assets/HomePage/image (4).png";
import image6 from "../../Assets/HomePage/image (5).png";
import image7 from "../../Assets/HomePage/image (6).png";
import image8 from "../../Assets/HomePage/image (7).png";
import { useNavigate } from "react-router-dom";

const ISOCompliance = () => {
  const navigate = useNavigate();

  const images = [
    {
      id: 1,
      src: image1,
      heading: "ISO 9001 CERTIFICATION",
      discription: "Quality Management System",
      link: "/iso-9001:2015",
    },
    {
      id: 2,
      src: image2,
      heading: "ISO 14001:2015 CERTIFICATION",
      link: "/iso-14001:2015",
      discription: "Environmental Management System",
    },
    {
      id: 3,
      src: image3,
      heading: "ISO 45001:2018 CERTIFICATION",
      link: "/iso-45001:2018",
      discription: "Health & Safety (OH&S) Management System",
    },
    {
      id: 4,
      src: image4,
      heading: "ISO 22000:2018 CERTIFICATION",
      link: "/iso-22000:2018",
      discription: "Food Safety Management System",
    },
    {
      id: 5,
      src: image5,
      heading: "ISO 20000-1:2018 CERTIFICATION",
      link: "/iso-20000-1:2018",
      discription: " Information Technology Service",
    },
    {
      id: 6,
      src: image6,
      heading: "ISO 13485:2016 CERTIFICATION",
      link: "/iso-13485:2016",
      discription: "Medical Devices - Quality Management Systems ",
    },
    {
      id: 7,
      src: image7,
      heading: "ISO 50001:2011 CERTIFICATION",
      link: "/iso-50001:2011",
      discription: "Energy Management System",
    },
    {
      id: 8,
      src: image8,
      heading: "27001:2013 CERTIFICATION",
      link: "/iso-27001:2013",
      discription: "Information Security Management System",
    },
  ];
  return (
    <>
      <div className="w-full text-center py-10 bg-[#F7FAFF]">
        {/* heading  */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#032303]">
            ISO Standards & Compliance <br />
            <span className="text-[#29AAE1]">Certification Services</span>
          </h2>

          <div className="flex justify-center w-full mb-6">
            <p className="mt-4 text-sm sm:text-base md:text-lg text-[#4D4D4D] leading-relaxed max-w-3xl mx-auto md:mx-0">
              We provide comprehensive guidance and end-to-end support to help
              your business obtain various ISO certifications and statutory
              compliance certificates, ensuring international standards
              compliance and operational excellence.
            </p>
          </div>
        </div>

        {/* images  */}
        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 gap-8 px-4 lg:px-12">
          {images.map((logo) => (
            <div
              key={logo.id}
              onClick={() => {
                navigate(`${logo?.link}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="cursor-pointer"
            >
              <div className="h-full flex flex-col justify-between bg-white hover:scale-[1.05] transition-transform duration-300 ease-in-out shadow-md rounded">
                {/* Image */}
                <div className="">
                  <img
                    src={logo.src}
                    alt={logo.heading}
                    className="w-full h-40 object-contain"
                    loading="lazy"
                  />
                </div>

                <hr className="border-gray-200" />

                {/* Text Content */}
                <div className="flex flex-col items-center justify-center gap-1 p-4">
                  <p className="font-semibold text-md text-[#032303] text-center">
                    {logo.heading}
                  </p>
                  <p className="font-medium text-sm text-[#29AAE1] text-center tracking-wide">
                    {logo.discription}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ISOCompliance;
